// extracted by mini-css-extract-plugin
export var divider = "_su-0";
export var systemMessage = "_su-1";